import api from "../Api";
import { BaseService } from "../BaseService";

const URL = "dashboards/ai-usage";

export class AIUsageDashboardService extends BaseService {
  async getKpis(params: any = {}): Promise<any> {
    try {
      return this.handleResponse(await api.get(`${URL}/kpis`, { params }));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async getCollaborators(params: any = {}): Promise<any> {
    try {
      return this.handleResponse(await api.get(`${URL}/collaborators`, { params }));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async getCategories(params: any = {}): Promise<any> {
    try {
      return this.handleResponse(await api.get(`${URL}/categories`, { params }));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }
}
